export var DeviceType;
(function (DeviceType) {
    DeviceType["ENERGYBOX_HUB"] = "ENERGYBOX_HUB";
    DeviceType["EB_SUPER_HUB"] = "EB_SUPER_HUB";
    DeviceType["ENERGYBOX_CB"] = "ENERGYBOX_CB";
    DeviceType["GHUB"] = "GHUB";
    DeviceType["ENERGYPRO"] = "ENERGYPRO";
    DeviceType["ENERGYPRO2"] = "ENERGYPRO2";
    DeviceType["THERMOSTAT"] = "THERMOSTAT";
    DeviceType["UNASSIGNED"] = "";
    // 'modBus',
})(DeviceType || (DeviceType = {}));
export var ThermostatModelType;
(function (ThermostatModelType) {
    ThermostatModelType["VENSTAR_THERMOSTAT"] = "VENSTAR_THERMOSTAT";
    ThermostatModelType["ENERGYBOX_THERMOSTAT"] = "ENERGYBOX_THERMOSTAT";
})(ThermostatModelType || (ThermostatModelType = {}));
export var DeviceTypeDisplayText;
(function (DeviceTypeDisplayText) {
    DeviceTypeDisplayText["ENERGYBOX_HUB"] = "Energybox Hub";
    DeviceTypeDisplayText["EB_SUPER_HUB"] = "SuperHub";
    DeviceTypeDisplayText["ENERGYBOX_CB"] = "SiteController";
    DeviceTypeDisplayText["ENERGYBOX_CB_US_10"] = "SiteController";
    DeviceTypeDisplayText["ENERGYBOX_CB_US_6"] = "SiteController";
    DeviceTypeDisplayText["ENERGYBOX_CB_EU_6"] = "SiteController";
    DeviceTypeDisplayText["ENERGYPRO"] = "EnergyPro I";
    DeviceTypeDisplayText["ENERGYPRO2"] = "EnergyPro II";
    DeviceTypeDisplayText["GHUB"] = "G-Hub";
    DeviceTypeDisplayText["THERMOSTAT"] = "Thermostat";
    DeviceTypeDisplayText["VENSTAR_THERMOSTAT"] = "Thermostat";
    DeviceTypeDisplayText["ENERGYBOX_THERMOSTAT"] = "Thermostat";
    DeviceTypeDisplayText["UNASSIGNED"] = "";
})(DeviceTypeDisplayText || (DeviceTypeDisplayText = {}));
export var SiteController;
(function (SiteController) {
    SiteController["ENERGYBOX_CB"] = "ENERGYBOX_CB";
    SiteController["ENERGYBOX_CB_US_10"] = "ENERGYBOX_CB_US_10";
    SiteController["ENERGYBOX_CB_US_6"] = "ENERGYBOX_CB_US_6";
    SiteController["ENERGYBOX_CB_EU_6"] = "ENERGYBOX_CB_EU_6";
})(SiteController || (SiteController = {}));
export var SiteControllerDisplayText;
(function (SiteControllerDisplayText) {
    SiteControllerDisplayText["ENERGYBOX_CB"] = "SiteController-16 (US)";
    SiteControllerDisplayText["ENERGYBOX_CB_US_10"] = "SiteController-10 (US)";
    SiteControllerDisplayText["ENERGYBOX_CB_US_6"] = "SiteController-6 (US)";
    SiteControllerDisplayText["ENERGYBOX_CB_EU_6"] = "SiteController-6 (EU)";
})(SiteControllerDisplayText || (SiteControllerDisplayText = {}));
export var DeviceConnectivityText;
(function (DeviceConnectivityText) {
    DeviceConnectivityText["ONLINE"] = "Online";
    DeviceConnectivityText["OFFLINE"] = "Offline";
})(DeviceConnectivityText || (DeviceConnectivityText = {}));
export const MapDeviceConnectivity = {
    ACTIVE: DeviceConnectivityText.ONLINE,
    true: DeviceConnectivityText.ONLINE,
    INACTIVE: DeviceConnectivityText.OFFLINE,
    false: DeviceConnectivityText.OFFLINE,
};
export var Vendor;
(function (Vendor) {
    Vendor["ENERGYBOX"] = "energybox";
    Vendor["MONNIT"] = "monnit";
    Vendor["VENSTAR"] = "venstar";
})(Vendor || (Vendor = {}));
